import { createStyleSheet } from 'jss-theme-reactor';

export const styleSheet = createStyleSheet('PromptDialog', () => {
  return {
    root: {
      '& > div > div > div': {
        boxShadow: 'none',
        borderRadius: 0,
        display: 'flex',
        width: 'inherit',
      },
    },
    title: {
      textAlign: 'center',
      margin: '0 38px 55px',
    },
    buttonsContainer: {
      display: 'flex',
      width: '80%',
      justifyContent: 'space-between',
      margin: '0 38px 30px',
      '& > button': {
        flexGrow: '1',
        margin: '0 4px',
      },
    },
    contentContainer: {
      display: 'flex',
      width: '80%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexGrow: 1,
    },
    displayNone: {
      display: 'none',
    },
  };
});

export const buttonSaveStyle = {
  height: '35px',
  lineHeight: '16px',
  borderRadius: 0,
  width: 'auto',
};

export const buttonCancelStyle = {
  height: '35px',
  border: '1px solid #00C5C1',
  lineHeight: '16px',
  borderRadius: 0,
  width: 'auto',
  transform: 'none',
};

export const buttonSaveLabelStyle = {
  fontSize: '16px',
  color: '#FFFFFF',
  textTransform: 'none',
};

export const buttonCancelLabelStyle = {
  fontSize: '16px',
  color: '#00C5C1',
  textTransform: 'none',
};
